/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/ReceiptEmailInput/Content/Content",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentsPostPaymentReceiptEmailValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'receipt.email',
})
let paymentsPostPaymentReceiptEmailIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payments_post_payment',
path: 'receipt.email',
validate: fromValidate.email,
required: true,
})
let paymentsPostPaymentReceiptEmailChangeData = fromData.useDataChange({ viewPath,
context: 'payments_post_payment',
path: 'receipt.email',
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="payments_post_payment.receipt.email"
 validate="/Data/validate.js email"
 value={paymentsPostPaymentReceiptEmailValueData}
 onChange={paymentsPostPaymentReceiptEmailChangeData}
 invalid={!paymentsPostPaymentReceiptEmailIsValidData}
 required={true}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Receipt email address"
 weight="medium"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 autoFocus={true}
 type="email"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}